import React from 'react';
import { get } from 'lodash';
import { useShowContextRequired } from 'ui-builder';
import { Project, ShortTaskDto } from 'nekst-api';

import styles from './NextKeyDateField.module.scss';
import useDueDateHelper from '../../view/tasks/list/dueDateHelper';
import { OpenTaskWrapper } from "./OpenTaskWrapper";

export default function NextKeyDateField(
  props: {
    // eslint-disable-next-line react/no-unused-prop-types
    label: string,
    source: string,
    testId?: string
  },
) {
  const dueDateHelper = useDueDateHelper();

  const showContext = useShowContextRequired<Project>();

  const data = showContext.data;

  const value = get(data, props.source) as ShortTaskDto | null;

  if (value) {
    return (
      <OpenTaskWrapper taskId={value.id} projectId={data.id}>
        <div data-testid={props.testId}>
          <div className={styles.name} title={value.name}>{value.name}</div>
          <div className={styles.dueDate}>
            {dueDateHelper.getStringValue(value.dueDate)}
          </div>
        </div>
      </OpenTaskWrapper>
    );
  } else {
    return (<>-</>);
  }

}
